import React, { createContext, useContext, useReducer, Dispatch } from "react";
import { Action, initialState, reducer, Settings } from "./hooks/useSettings";

const SettingsContext = createContext<[Settings, Dispatch<Action>] | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const state: [Settings, Dispatch<Action>] = useReducer(reducer, initialState);
    return <SettingsContext.Provider value={state}>{children}</SettingsContext.Provider>;
};

export const useSettings = (): [Settings, Dispatch<Action>] => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error("useSettings must be used within a SettingsProvider");
    }
    return context;
};
